module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('container', [_c('div', {
    staticClass: "info"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/past-run"
    }
  }, [_vm._v("↩ Back")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "large",
      "padding": "14px 10px 0px 0px"
    }
  }, [_vm._v("Recording:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-width": "300px"
    }
  }, [_c('audio', {
    attrs: {
      "id": "my-audio",
      "controls": ""
    },
    on: {
      "ended": _vm.playEnd
    }
  }, [_c('source', {
    attrs: {
      "src": ("https://liverun-bucket.s3.amazonaws.com/spreaker-live/live-" + (this.$route.params.raceId) + ".mp3"),
      "type": "audio/mp3"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "race_desc"
  }, [_c('span', [_vm._v("Description")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrapper_description"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.race.description))])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn--primary load_data",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "id": "loaddatafb"
    },
    on: {
      "click": function($event) {
        _vm.fromFireBase()
      }
    }
  }, [_vm._v("Load From Firebase\n      ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.currentChannel) ? _c('div', {
    staticClass: "channelInfo"
  }, [_c('div', [_vm._v("Channel : " + _vm._s(_vm.channel))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.id))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.pwd))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.desc))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "question",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftcolumn"
    }
  }, [_vm._v(_vm._s(_vm.todayQuestion))])]), _vm._v(" "), _c('span', {
    staticClass: "question",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftcolumn"
    }
  }, [_vm._v(_vm._s(_vm.race.quoteOfDay))])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn--primary load_data",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "id": "downloadcsv"
    },
    on: {
      "click": function($event) {
        _vm.downloadCSV()
      }
    }
  }, [_vm._v("Export as CSV\n      ")]), _vm._v(" "), _c('toggle-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px"
    },
    attrs: {
      "id": "changed-font",
      "width": 85,
      "height": 30,
      "speed": 480,
      "color": {
        unchecked: '#413b94',
        checked: '#ff5627'
      },
      "labels": {
        checked: 'Km',
        unchecked: 'Miles'
      }
    },
    on: {
      "change": function($event) {
        _vm.onToggle()
      }
    },
    model: {
      value: (_vm.distanceInKm),
      callback: function($$v) {
        _vm.distanceInKm = $$v
      },
      expression: "distanceInKm"
    }
  })], 1), _vm._v(" "), _c('v-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "10.5px"
    },
    attrs: {
      "is-horizontal-resize": "",
      "columns": _vm.columnsT,
      "column-cell-class-name": _vm.columnCellClass,
      "table-data": _vm.tableDataT,
      "show-vertical-border": true,
      "odd-bg-color": '#cfe2f3',
      "title-row-height": 60,
      "row-height": 45,
      "border": 1
    },
    on: {
      "on-custom-comp": _vm.customCompFunc
    }
  }), _vm._v(" "), _c('jw-pagination', {
    attrs: {
      "items": _vm.runnerList,
      "disableDefaultStyles": true
    },
    on: {
      "changePage": _vm.onPageChange
    }
  }), _vm._v(" "), _c('lucky-live-runner', {
    attrs: {
      "details": _vm.detail,
      "show": _vm.showModal
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b33d6c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RaceDetail.vue
// module id = 1792
// module chunks = 1